import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import images from '_images';
import { goToTop } from '_helpers';

import * as actions from './redux/actions';

import {
  DamagedCartIcon,
  MissedPickupIcon,
  RequestPickupIcon,
  DifferentProblemIcon,
  TechnicalProblemIcon,
  WrongInformationIcon,
  NotGettingRemindersIcon,
} from './components';

const Container = styled.div`
    width: 100%;
    margin: 0 auto;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    min-height: 350px;
`;

const Header = styled.h2`
    font-size: 24px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    margin-bottom: 15px;
`;

const Address = styled.p`
    color: #747474;
    font-size: 16px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    margin-top: 5px;
    margin-bottom: 25px;
`;

const Button = styled.button`
    gap: 10px;
    width: 100%;
    height: auto;
    border: none;
    display: flex;
    padding: 15px;
    cursor: pointer;
    min-height: 50px;
    margin-bottom: 5px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid #dbdbdb;
    padding-left: 0 !important;
    align-items: center;
`;

const IconContainer = styled.div`
    max-width: 40px;
    flex: 1;
`;

const TitleContainer = styled.div`
    flex: 1;
`;

const Title = styled.p`
    margin: 0;
    padding: 0;
    font-size: 16px;
    text-align: left;
    font-family: Roboto, sans-serif;
`;

const ArrowContainer = styled.div`
    flex: 1;
    max-width: 16px;
`;

const Arrow = styled.img`
  width: 100%;
  height: 100%;
`;

const helpItemTypes = {
  other: (<DifferentProblemIcon />),
  damaged_cart: (<DamagedCartIcon />),
  missed_pickup: (<MissedPickupIcon />),
  wrong_info: (<WrongInformationIcon />),
  pickup_request: (<RequestPickupIcon />),
  technical_problem: (<TechnicalProblemIcon />),
  reminder_problem: (<NotGettingRemindersIcon />),
};

const HelpScreen = ({
  zone, help, props, setFromHelp
}) => {
  const { helpItems } = help;
  const { mapCityName, fullAddress, zoneStr } = zone;
  const { history } = props;

  const navigate = ({ path, params }) => {
    goToTop();

    /** User should set zones first */
    if (path === '/help/confirm-location' && !zoneStr) return history.push('/zone-setup', { ...params });
    setFromHelp(true);
    return history.push(path.includes('damaged-cart') ? `${path}/${params.oidx}` : path, { ...params });
  };
  return (
    <Container>
      <Header>{_('help.how_can_we_help_you')}</Header>
      <Address>{fullAddress || mapCityName.search_nm}</Address>
      <ul style={{ padding: 0 }}>
        {
          helpItems
            .filter(({ shouldDisplay }) => shouldDisplay)
            .map(({
              oidx, type, title, route, has_advanced_settings
            }) => (
              <li style={{ listStyle: 'none' }}>
                <Button
                  key={oidx}
                  onClick={() => {
                    if (type === 'PICKUP_REQUEST' && has_advanced_settings) {
                      history.push('/bulk-pickup');
                    } else {
                      navigate(route);
                    }
                  }}
                >
                  <IconContainer>
                    {helpItemTypes[type.toLowerCase()]}
                  </IconContainer>

                  <TitleContainer>
                    <Title>{title}</Title>
                  </TitleContainer>

                  <ArrowContainer>
                    <Arrow src={images.calendar.rightArrow} alt />
                  </ArrowContainer>
                </Button>
              </li>
            ))
        }
      </ul>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setFromHelp: (fromHelp) => dispatch(actions.setFromHelp(fromHelp)),
});

export default connect(null, mapDispatchToProps)(HelpScreen);
